import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";

export default function Pricing() {
  const { access } = useAuth();
  const [loading, setLoading] = useState(false);

  const startCheckout = async (packageId = "journey90") => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin, package_id: packageId });
      window.location.href = data.url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Checkout failed.");
      setLoading(false);
    }
  };

  return (
    <div className="space-y-10 max-w-3xl">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-sage font-bold mb-2">Unlock lifetime</p>
        <h1 className="font-serif text-4xl md:text-5xl font-medium">One quiet price, forever.</h1>
      </div>

      {access?.is_paid ? (
        <div className="bg-moss/10 rounded-3xl border border-moss/30 p-8">
          <p className="font-serif text-2xl text-moss">You're a lifetime member.</p>
          <p className="text-muted-foreground mt-2">Thank you for trusting this practice.</p>
        </div>
      ) : (
        <div className="relative bg-white rounded-3xl border border-border p-8 md:p-12 soft-shadow-lg overflow-hidden">
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-sage/20 blur-3xl"></div>
          <div className="relative">
            <h3 className="font-serif text-3xl mb-2 font-medium">Lifetime access</h3>
            <p className="text-muted-foreground mb-6">All 90 days. All features. Yours, forever.</p>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="font-serif text-5xl font-medium">$29.99</span>
              <span className="text-muted-foreground">one-time</span>
            </div>
            <ul className="space-y-3 mb-8">
              {[
                "All 90 daily prompts",
                "AI-personalized journaling (Claude Sonnet 4.5)",
                "Goals, todos, mood, gratitude, habits",
                "Mood charts & streak tracking",
                "Lifetime access — no subscription",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-clay mt-2 shrink-0" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
            <button onClick={() => startCheckout("journey90")} disabled={loading} data-testid="pricing-checkout"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-moss text-white hover:bg-mossDark disabled:opacity-60 transition-all">
              {loading ? "Opening checkout…" : "Continue to checkout"} <ArrowRight size={16} />
            </button>
            <div className="flex flex-wrap gap-3 mt-4">
              <button onClick={() => startCheckout("grief180")} disabled={loading} data-testid="pricing-grief"
                      className="px-5 py-2.5 rounded-full bg-clay text-white hover:bg-clay/90 text-sm transition-all">
                Moving through Grief · $39.99
              </button>
              <button onClick={() => startCheckout("sober30")} disabled={loading} data-testid="pricing-sober"
                      className="px-5 py-2.5 rounded-full bg-sage text-white hover:bg-sage/90 text-sm transition-all">
                Sober Living · $15.99
              </button>
              <button onClick={() => startCheckout("bundle")} disabled={loading} data-testid="pricing-bundle"
                      className="px-5 py-2.5 rounded-full bg-charcoal text-white hover:bg-charcoal/90 text-sm transition-all">
                Bundle of 3 · $79.99
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
